// config.js (CRA)
const PROD = process.env.NODE_ENV === 'production';

// For production, REQUIRE an https endpoint (ngrok/tunnel/proxy).
// For local dev, default to localhost:5000.
const API_BASE_URL = PROD
  ? process.env.REACT_APP_API_BASE_URL // e.g. https://subglottal-frankie-nontempered.ngrok-free.dev
  : (process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000');

const CHATBOT_API_URL = PROD
  ? process.env.REACT_APP_CHATBOT_API_URL // e.g. https://subglottal-frankie-nontempered.ngrok-free.dev
  : (process.env.REACT_APP_CHATBOT_API_URL || 'http://localhost:8000');


// --- enforce that prod must have HTTPS endpoint ---
if (PROD && !CHATBOT_API_URL) {
  throw new Error('❌ Missing REACT_APP_CHATBOT_API_URL in production build');
}

const config = { API_BASE_URL, CHATBOT_API_URL };
export default config;
